import { MainWindow } from '@mobile-mapping/ui';
import { JSX } from 'solid-js';
import { useUrlSync } from '../hooks/useUrlSync';
import { getConfig } from '../../config/config';
import { getDeployWeb3dPath } from '../../utils/web3d-path';

const HomePage = (): JSX.Element => {
  const { urlSyncComplete } = useUrlSync();

  return (
    <MainWindow
      web3DPath={getDeployWeb3dPath()}
      helpUrl={getConfig().helpUrl}
      profileUrl={getConfig().profileUrl}
      urlSyncComplete={urlSyncComplete}
    />
  );
};

export default HomePage;
